module.exports = __webpack_public_path__ + "8c4ce528fc9fcd3a8418dbfe03b045b6.jpg";